import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { fromEvent, merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'brn-table-actions',
  templateUrl: './table-actions.component.html',
  styleUrls: ['./table-actions.component.scss'],
})
export class TableActionsComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input('table') table!: HTMLTableElement;
  @Input('active') active!: boolean;
  @Input('change') change!: number;
  @ViewChild('actions') actions!: ElementRef;

  private unsubscribe$: Subject<any> = new Subject();

  ngOnChanges(ch: SimpleChanges) {
    if (ch.change && !ch.change.firstChange) {
      this.actions.nativeElement.style.top = 0 + 'px';
    }
  }

  ngAfterViewInit(): void {
    merge(
      fromEvent<any>(this.table, 'mousemove').pipe(
        takeUntil(this.unsubscribe$)
      ),
      fromEvent<any>(this.table, 'click').pipe(takeUntil(this.unsubscribe$))
    )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event) => {
          if (!event.target.closest('.brn-table-actions')) {
            var rect = this.table.getBoundingClientRect(),
              height = this.actions.nativeElement.offsetHeight,
              top = event.clientY - rect.top - height / 2;
            if (top < 0) {
              top = 0;
            }
            if (top + height > rect.bottom - rect.top) {
              top = rect.bottom - rect.top - height;
            }
            this.actions.nativeElement.style.top = top + 'px';
          }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
